import FileTab from '../FileTab'
import FileTabGreen from '../FileTabGreen'

export default function FilesDisplay({
  arr = [],
  path,
  display,
  newTab = false,
  marginTop,
}) {
  return (
    arr?.length > 0 && (
      <div
        className={`${display ? display : 'flex'} items-center ${
          marginTop ? marginTop : 'mt-16'
        }`}
      >
        {arr.map((ele, i) =>
          newTab ? (
            <FileTabGreen
              key={i}
              index={i}
              fileLink={`${process.env.NEXT_PUBLIC_IMG_PATH}${ele[path]}`}
            />
          ) : (
            <FileTab
              key={i}
              index={i}
              fileLink={`${process.env.NEXT_PUBLIC_IMG_PATH}${ele[path]}`}
            />
          )
        )}
      </div>
    )
  )
}
